import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { getById } from "@insite/client-framework/Store/Data/DataState";

export function getOrderReminderStateById(state: ApplicationStateTKCCP, OrderHistoryId: string) {
    return getById(state.orderReminder, OrderHistoryId);
}
